import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { MatPaginator, MatTableDataSource, MatSnackBar, MatDialog, PageEvent } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ClienteinfoService } from 'src/app/services/clienteinfo.service';
import { DescargarLotesComponent } from '../descargar-lotes/descargar-lotes.component';
import { CitaTentativaHelperService } from 'src/app/services/cita-tentativa-helper.service';

@Component({
  selector: 'app-fib-proactivos',
  templateUrl: './fib-proactivos.component.html',
  styleUrls: ['./fib-proactivos.component.scss']
})
export class FibProactivosComponent implements OnInit, OnDestroy {

  public agente: any;
  private semaforoInterval: any;
  pageSize = 25;
  FILTER: string = null;
  fechaInicio: string = null;
  fechaFin: string = null;
  contadorEntrantes: number = 0;
  contadorAceptadas: number = 0;
  contadorAgendadas: number = 0;
  
  estadosEntrada = [
    { value: null, label: 'Todos' },
    { value: 1, label: 'Candidato a Contactar' },
    { value: 2, label: 'Primer Contacto Enviado' },
    { value: 3, label: 'Segundo Contacto Enviado' },
    { value: 4, label: 'Tercer Contacto Enviado' },
    { value: 5, label: 'Cuarto Contacto Telefónicamente' },
    { value: 6, label: 'Cliente Agenda Visita' },
    { value: 7, label: 'Técnico Asignado Visita en Curso' },
    { value: 8, label: 'Cerrado' },
    { value: 9, label: 'Cliente No Acepta Visita' },
    { value: 10, label: 'Candidato en Garantía' },
    { value: 11, label: 'Cliente Acepta Visita' },
    { value: 12, label: 'Cliente no Responde' },
    { value: 13, label: 'Intento de Contacto Manual 1' },
    { value: 14, label: 'Intento de Contacto Manual 2' },
    { value: 15, label: 'Intento de Contacto Manual 3' },
    { value: 16, label: 'Cliente No Contactado' },
    { value: 17, label: 'Cliente Solicita Rellamar' }
  ];

  // Filtro por estado de entrega del mensaje del estado actual del contacto
  estadosEntrega = [
    { value: null, label: 'Todos' },
    { value: 'ENTREGADO', label: 'Entregado' },
    { value: 'FALLIDO', label: 'Fallido' },
    { value: 'ENVIADO', label: 'Enviado (sin confirmar)' },
    { value: 'SIN_REGISTRO', label: 'Sin registro' }
  ];

  grupoValFIBProactivos = new FormGroup({
    filtro: new FormControl(''),
    telefono: new FormControl(''),
    cuenta: new FormControl(''),
    falla: new FormControl(''),
    estado_entrada: new FormControl(null),
    estado_entrega_mensaje: new FormControl(null)
  });

  reporteColumnsFIBProactivos: string[] = [];
  dataSourceFIBProactivos = new MatTableDataSource<any>([]);
  resultsLengthFIBProactivos: number = 0;

  @ViewChild('fibproactivosPaginator') fibproactivosPaginator: MatPaginator;
  @ViewChild('fibProactivosTable') fibProactivosTable: any;

  constructor(
    public pageTitle: ComponentPageTitle,
    private gateway: GatewayService,
    private spinner: NgxSpinnerService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private clienteinfo: ClienteinfoService,
    private dialog: MatDialog,
    private tentativaHelper: CitaTentativaHelperService
  ) {
    this.agente = this.localSave.get('usuarioPGV');
  }

  ngOnInit() {
    this.pageTitle.title = 'Proactivos';
    // Cargar datos al inicializar
    this.getFIBProactivos(0);
    this.semaforoInterval = setInterval(() => { this.cdr.detectChanges(); }, 60000);
  }

  trackByColumn(index: number, column: string): string {
    return column;
  }

  getDisplayedColumns(): string[] {
    // Vista supervisor: solo TELEFONO y columnas dinámicas (sin ACCION)
    return ['SEMAFORO', 'TELEFONO', ...this.reporteColumnsFIBProactivos];
  }

  formatColumnName(column: string): string {
    // Convertir nombres de columnas a formato legible
    // Ejemplo: 'acct_contact_phone1' -> 'ACCT CONTACT PHONE1'
    if (column === 'estado_entrega_mensaje') { return 'ESTADO DEL MENSAJE'; }
    return column.replace(/_/g, ' ').toUpperCase();
  }

  // Etiqueta legible del estado de entrega del mensaje
  formatEntrega(valor: string): string {
    switch (valor) {
      case 'ENTREGADO': return 'Entregado';
      case 'FALLIDO': return 'Fallido';
      case 'ENVIADO': return 'Enviado';
      case 'SIN_REGISTRO': return '';   // vacío en la grilla para no meter ruido
      default: return '';
    }
  }

  // ¿La columna es la de "Estado de Entrada"? (varios alias posibles del backend)
  esColumnaEstado(column: string): boolean {
    return column === 'estado_de_entrada' || column === 'estado entrada'
        || column === 'ESTADO_DE_ENTRADA' || column === 'ESTADO ENTRADA'
        || column === 'Estado de Entrada';
  }

  // ¿Mostrar chip de entrega en la celda de estado? (solo 1er/2do/3er contacto con entrega real)
  tieneEntregaVisible(row: any): boolean {
    if (!row) return false;
    const est = Number(row.id_estado_de_entrada);
    return (est === 2 || est === 3 || est === 4)
        && ['ENTREGADO', 'ENVIADO', 'FALLIDO'].indexOf(row.estado_entrega_mensaje) !== -1;
  }

  // Estilo del chip de entrega según el estado (iconografía tipo WhatsApp)
  getChipEntregaStyle(row: any): { cssClass: string, icon: string, tooltip: string } {
    switch (row.estado_entrega_mensaje) {
      case 'ENTREGADO': return { cssClass: 'chip-entrega-ok', icon: 'done_all', tooltip: 'Mensaje WhatsApp entregado' };
      case 'FALLIDO': return { cssClass: 'chip-entrega-fail', icon: 'error_outline', tooltip: row.razon_entrega_mensaje ? ('No entregado: ' + row.razon_entrega_mensaje) : 'Mensaje no entregado' };
      default: return { cssClass: 'chip-entrega-pend', icon: 'done', tooltip: 'Mensaje enviado, sin confirmación de entrega' };
    }
  }

  onClickChipTentativa(row: any): void {
    const idcliente = row.idcliente || row.IDCLIENTE || row.IdCliente;
    const telefono = row.TELEFONO || row.Telefono || row.telefono || row.acct_contact_phone1;
    const idcampana = row.idcampana || 199;
    const idContactoIsoft = row.id || row.ID;
    // Priorizar cuenta (account_id) para evitar buscar por idcliente incorrecto
    // cuando base.cuenta tiene multiples base.id
    const cuenta = row.Cuenta || row.cuenta || row.CUENTA || row.account_id;
    if (!cuenta) {
      this.snackbar.open('No se encontró cuenta para buscar la tentativa.', 'Cerrar', { duration: 3000 });
      return;
    }
    // Vista supervisor: ocultar boton "Atender cliente" (solo lectura)
    this.tentativaHelper.openTentativaParaCliente(idcliente, telefono, idcampana, false, idContactoIsoft, cuenta);
  }

  ngOnDestroy() {
    if (this.semaforoInterval) {
      clearInterval(this.semaforoInterval);
    }
  }

  getSemaforoAceptaVisita(row: any): { color: string, icon: string, tooltip: string } | null {
    if (!row) return null;
    const idEstado = Number(row.id_estado_de_entrada);
    if (idEstado !== 11 && idEstado !== 10) return null;
    const min = row.minutos_en_estado;
    if (min == null || min < 0) return null;
    if (min > 30) return { color: 'rojo', icon: 'alarm', tooltip: 'Más de 30 min en este estado — requiere atención urgente' };
    if (min > 15) return { color: 'amarillo', icon: 'warning', tooltip: 'Entre 15 y 30 min — se acerca el límite' };
    return { color: 'verde', icon: 'check_circle', tooltip: 'Menos de 15 min — recién ingresó a este estado' };
  }

  tieneTentativaVisible(row: any): boolean {
    if (!row) return false;
    return Number(row.tiene_tentativa) === 1 || Number(row.id_estado_de_entrada) === 11;
  }

  getChipTentativaStyle(row: any): { cssClass: string, tooltip: string } {
    if (Number(row.id_estado_de_entrada) === 11) {
      return { cssClass: 'chip-tentativa-activa', tooltip: 'Cita tentativa activa - Click para ver detalles' };
    }
    return { cssClass: 'chip-tentativa-referencia', tooltip: 'Cliente tiene cita tentativa pendiente - Click para ver' };
  }

  public isDateColumn(column: string): boolean {
    // Detectar si una columna es de tipo fecha (excluyendo solo horas)
    const dateKeywords = ['fecha', 'date', 'inicio', 'fin', 'final', 'cleared'];
    const excludeKeywords = ['notification_count', 'count', 'time', 'tiempo']; // Excluir columnas que no son fechas
    const columnLower = column.toLowerCase();
    
    // Excluir si contiene palabras clave de exclusión
    if (excludeKeywords.some(keyword => columnLower.includes(keyword))) {
      return false;
    }
    
    // Incluir si contiene palabras clave de fecha
    return dateKeywords.some(keyword => columnLower.includes(keyword));
  }

  public isTimeOnlyValue(value: any): boolean {
    // Verificar si el valor es solo una hora (no una fecha completa)
    if (!value) {
      return false;
    }
    
    if (typeof value === 'string') {
      // Patrón para detectar solo hora: HH:mm:ss o HH:mm
      const timeOnlyPattern = /^\d{1,2}:\d{2}(:\d{2})?$/;
      return timeOnlyPattern.test(value.trim());
    }
    
    return false;
  }

  public cambioElementosFIBProactivos(event?: PageEvent) {
    this.getFIBProactivos(event.pageIndex);
  }

  generarFIBProactivos() {
    if (this.fibproactivosPaginator) {
      this.fibproactivosPaginator.firstPage();
    }
    this.getFIBProactivos(0);
  }

  getFIBProactivos(page) {
    if (page == 0) {
      if (this.fibproactivosPaginator) {
        this.fibproactivosPaginator.firstPage();
      }
    }
    
    let estadoEntradaSeleccionado = this.grupoValFIBProactivos.controls.estado_entrada.value;
    // Si es null, no incluir estado_entrada (no filtrar por estado en supervisor)
    let estadoEntradaNumero = estadoEntradaSeleccionado 
      ? (Array.isArray(estadoEntradaSeleccionado) ? estadoEntradaSeleccionado[0] : estadoEntradaSeleccionado)
      : null;

    let params: any = {
      page: page,
      pageSize: this.pageSize,
      sortBy: "Cuenta",
      sortOrder: "ASC"
    };

    // Agregar estado_entrada solo si hay selección
    if (estadoEntradaNumero !== null) {
      params.estado_entrada = estadoEntradaNumero;
    }

    // Filtro por estado de entrega del mensaje (solo si hay selección)
    const entregaSel = this.grupoValFIBProactivos.controls.estado_entrega_mensaje.value;
    if (entregaSel) {
      params.estado_entrega_mensaje = entregaSel;
    }

    // Agregar filtros solo si tienen valor
    let telefono = this.grupoValFIBProactivos.controls.telefono.value;
    let cuenta = this.grupoValFIBProactivos.controls.cuenta.value;
    let falla = this.grupoValFIBProactivos.controls.falla.value;
    let nombre = this.FILTER || this.grupoValFIBProactivos.controls.filtro.value;

    if (telefono) params.telefono = telefono;
    if (cuenta) params.cuenta = cuenta;
    if (falla) params.falla = falla;
    if (nombre) params.nombre = nombre;
    if (this.fechaInicio) params.fecha_desde = this.fechaInicio;
    if (this.fechaFin) params.fecha_hasta = this.fechaFin;
    this.spinner.show();

    this.gateway.get('listarContacto', params).then((result: any) => {
      let contactos = result.rows || [];

      // Resuelve el total: usa respuesta combinada o cae a endpoint de conteo (fallback)
      const resolveTotal = () => {
        if (result.total !== undefined) {
          this.resultsLengthFIBProactivos = result.total;
          this.spinner.hide();
        } else {
          this.gateway.get('listarContactoCount', params).then((countResult: any) => {
            this.resultsLengthFIBProactivos = countResult.rows[0].total;
            this.spinner.hide();
          }).catch(() => {
            this.spinner.hide();
          });
        }
      };

      if (!contactos || contactos.length === 0) {
        this.dataSourceFIBProactivos = new MatTableDataSource([]);
        this.resultsLengthFIBProactivos = 0;
        resolveTotal();
        return;
      }

      // Contadores del día
      if (result.contadores) {
        this.contadorEntrantes = result.contadores.total_hoy || 0;
        this.contadorAceptadas = result.contadores.aceptadas_hoy || 0;
        this.contadorAgendadas = result.contadores.agendadas_hoy || 0;
      }

      // Si no hay columnas definidas, intentar obtenerlas del primer elemento
      if (this.reporteColumnsFIBProactivos.length === 0 && contactos.length > 0) {
        let columnas = Object.keys(contactos[0]);
        // Filtrar TELEFONO, idcliente, id y variantes para no duplicar columna explícita
        columnas = columnas.filter(key =>
          !['TELEFONO', 'Telefono', 'telefono', 'acct_contact_phone1', 'ACCT_CONTACT_PHONE1', 'phone', 'PHONE', 'phone1', 'PHONE1', 'idcliente', 'IDCLIENTE', 'IdCliente', 'id', 'ID', 'Id', 'id_estado_de_entrada', 'minutos_en_estado', 'tiene_tentativa', 'intento_bloqueado_hoy', 'razon_entrega_mensaje', 'codigo_entrega_mensaje'].includes(key)
        );
        // NO agregar ACCION aquí porque se define estáticamente en el HTML
        this.reporteColumnsFIBProactivos = [...columnas];
      }

      // Asignar datos directamente al dataSource
      this.dataSourceFIBProactivos = new MatTableDataSource(contactos);

      // Forzar detección de cambios después de generar columnas y actualizar dataSource
      this.cdr.detectChanges();

      // Esperar un ciclo de renderizado
      setTimeout(() => {
        if (this.fibProactivosTable) {
          this.fibProactivosTable.updateStickyColumnStyles();
        }
        this.cdr.detectChanges();
      }, 100);

      resolveTotal();
    }).catch((e) => {
      this.spinner.hide();
      this.snackbar.open('Error al cargar los datos de FIB Proactivos.', 'Cerrar', { duration: 3000 });
    });
  }

  keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.applyFIBProactivosFilter();
    }
  }

  applyFIBProactivosFilter() {
    this.FILTER = this.grupoValFIBProactivos.controls.filtro.value || '';
    if (this.fibproactivosPaginator) {
      this.fibproactivosPaginator.firstPage();
    }
    this.getFIBProactivos(0);
  }

  limpiarFiltrosFIBProactivos() {
    this.grupoValFIBProactivos.reset({ filtro: '', telefono: '', cuenta: '', falla: '', estado_entrada: null, estado_entrega_mensaje: null });
    this.FILTER = null;
    this.fechaInicio = null;
    this.fechaFin = null;
    if (this.fibproactivosPaginator) {
      this.fibproactivosPaginator.firstPage();
    }
    this.getFIBProactivos(0);
  }

  onFechaRangeChange(range: any) {
    this.fechaInicio = range && range.fechaDesde ? range.fechaDesde : null;
    this.fechaFin = range && range.fechaHasta ? range.fechaHasta : null;
    if (this.fibproactivosPaginator) {
      this.fibproactivosPaginator.firstPage();
    }
    this.getFIBProactivos(0);
  }

  descargar() {
    let params: any = { sortBy: 'Cuenta', sortOrder: 'ASC' };
    const estadoVal = this.grupoValFIBProactivos.controls.estado_entrada.value;
    if (estadoVal !== null) params.estado_entrada = estadoVal;
    const entregaVal = this.grupoValFIBProactivos.controls.estado_entrega_mensaje.value;
    if (entregaVal) params.estado_entrega_mensaje = entregaVal;
    const telefono = this.grupoValFIBProactivos.controls.telefono.value;
    const cuenta = this.grupoValFIBProactivos.controls.cuenta.value;
    const falla = this.grupoValFIBProactivos.controls.falla.value;
    const nombre = this.FILTER || this.grupoValFIBProactivos.controls.filtro.value;
    if (telefono) params.telefono = telefono;
    if (cuenta) params.cuenta = cuenta;
    if (falla) params.falla = falla;
    if (nombre) params.nombre = nombre;
    if (this.fechaInicio) params.fecha_desde = this.fechaInicio;
    if (this.fechaFin) params.fecha_hasta = this.fechaFin;

    const ahora = new Date();
    const ts = ahora.getFullYear() + ('0' + (ahora.getMonth() + 1)).slice(-2) + ('0' + ahora.getDate()).slice(-2) + '_' + ('0' + ahora.getHours()).slice(-2) + ('0' + ahora.getMinutes()).slice(-2);

    this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'listarContactoCount',
        nombreServicioRegistros: 'listarContactoDescarga',
        nombreArchivo: `proactivos_${ts}.xlsx`,
        params: params
      }
    });
  }

  llamarFIBProactivo(element) {
    this.spinner.show();

    const telefono = element.TELEFONO || element.Telefono || element.telefono || element.acct_contact_phone1;
    const idcliente = element.idcliente != null ? element.idcliente : (element.IDCLIENTE != null ? element.IDCLIENTE : element.IdCliente);
    const idcampana = 199;

    if (!telefono) {
      this.snackbar.open('No se encontró número de teléfono.', 'Cerrar', { duration: 5000 });
      this.spinner.hide();
      return;
    }
    if (idcliente == null || idcliente === undefined) {
      this.snackbar.open('No se encontró idcliente para este contacto.', 'Cerrar', { duration: 5000 });
      this.spinner.hide();
      return;
    }

    const clienteactivo = {
      idcliente: idcliente,
      telefono: telefono,
      idcampana: idcampana
    };
    const campana = { idcampana: idcampana };
    this.clienteinfo.setcliente(clienteactivo, campana, this.localSave.get('usuarioPGV').idagente);

    this.localSave.set('clienteFromFIB', true);
    this.router.navigate(['/homeagente/atencioncliente'])
      .then((e) => {
        this.spinner.hide();
      });
  }
}

